import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import { useMemo } from 'react';

export function useObservationTexts() {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_OBSERVATIONS);
  return useMemo(
    () => ({
      description: t('description'),
      filters: {
        school: {
          label: t('filters.school.label'),
          placeholder: t('filters.school.placeholder'),
        },
        session: {
          label: t('filters.session.label'),
          placeholder: t('filters.session.placeholder'),
        },
        student: {
          label: t('filters.student.label'),
          placeholder: t('filters.student.placeholder'),
        },
        studyPlan: {
          label: t('filters.studyPlan.label'),
          placeholder: t('filters.studyPlan.placeholder'),
        },
        campus: {
          label: t('filters.campus.label'),
          placeholder: t('filters.campus.placeholder'),
        },
        graduatedYear: {
          label: t('filters.graduatedYear.label'),
          placeholder: t('filters.graduatedYear.placeholder'),
        },
        course: {
          label: t('filters.course.label'),
          placeholder: t('filters.course.placeholder'),
        },
      },
      actions: {
        search: t('filters.actions.search'),
        clean: t('filters.actions.clean'),
      },
      columns: {
        student: t('columns.student'),
        studyPlan: t('columns.studyPlan'),
        campus: t('columns.campus'),
        graduatedYear: t('columns.graduatedYear'),
        course: t('columns.course'),
        levelRisk: t('columns.levelRisk'),
        situation: t('columns.situation'),
        conditionality: t('columns.conditionality'),
        actions: t('columns.actions'),
      },
    }),
    [t],
  );
}
